'use client';
export {
  createSliderScope,
  //
  Slider,
  SliderTrack,
  SliderRange,
  SliderThumb,
  //
  Root,
  Track,
  Range,
  Thumb,
} from './Slider';
export type { SliderProps, SliderTrackProps, SliderRangeProps, SliderThumbProps } from './Slider';
